import React from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import { ThemeProvider } from "@material-ui/styles";
import theme from "../../../theme";

interface Props {
  message: string;
  onConfirm: () => any;
  onCancel: () => any;
}

const UserConfirmation = ({ message, onConfirm, onCancel }: Props) => {
  return (
    <>
      <ThemeProvider theme={theme}>
        <Dialog
          open={true}
          onClose={onCancel}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">{"Upozorenje"}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              {message}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={onCancel} color="primary" variant="outlined">
              Ne
            </Button>
            <Button onClick={onConfirm} color="primary" variant="contained">
              Da
            </Button>
          </DialogActions>
        </Dialog>
      </ThemeProvider>
      ;
    </>
  );
};

export default UserConfirmation;
